import { KuoriLogo } from "../../shared/logo.js";

export const HOME_HREF = "/cerimonialistas/";

export function HomeLink({ height = 20 }: { readonly height?: number }) {
  return (
    <a class="d-home" href={HOME_HREF} aria-label="Kuori, voltar para a página">
      <KuoriLogo height={height} />
    </a>
  );
}
